import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import ItemsDisplayer from './app/domain/items-displayer';
import { MessageAdapterService } from './app/adapters/message-adapter.service';
import { ItemAdapterService } from './app/adapters/item-adapter.service';
import MessagesDisplayer from './app/domain/messages-displayer';
import { UserAdapterService } from './app/adapters/user-adapter.service';
import UsersDisplayer from './app/domain/users-displayer'; 
import { provideHttpClient } from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { environment } from './environments/environment';
import { ModulesDisplayer } from './app/domain/modules-displayer';
import { ModuleAdapterService } from './app/adapters/module-adapter.service';
import { CardsDisplayer } from './app/domain/cards-displayer';
import { CardAdapterService } from './app/adapters/card-adapter.service';
import { TiamAdapterService } from './app/adapters/tiam-adapter.service';
import { TiamDisplayer } from './app/domain/tiam-displayer';

addStyle(`${environment.feedbackTool.url}/modalComponentHybrid/feedback.css`,'feedback_css');
addScript(`${environment.feedbackTool.url}/modalComponentHybrid/feedback.js`, 'feedback_js');
 
function addScript(src: string, id: string) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.setAttribute('type', 'text/javascript');
    s.setAttribute('language', 'JavaScript');
    s.setAttribute('id', id);
    s.setAttribute('src', src);
    s.addEventListener('load', resolve);
    s.addEventListener('error', reject);
    document.body.appendChild(s);
  });
}

function addStyle(src: string, id: string) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('link');
    s.setAttribute('type', 'text/css');
    s.setAttribute('rel', 'stylesheet');
    s.setAttribute('id', id);
    s.setAttribute('href', src);
    s.addEventListener('load', resolve);
    s.addEventListener('error', reject);
    document.body.appendChild(s);
  });
}

appConfig.providers.push([ 
  provideHttpClient(),
  provideNoopAnimations(),
  {provide: 'IDisplayItems', useClass: ItemsDisplayer},
  {provide: 'IDisplayModules', useClass: ModulesDisplayer},
  {provide: 'IManageModules', useClass: ModuleAdapterService},
  {provide: 'IDisplayCards', useClass: CardsDisplayer},
  {provide: 'IManageCards', useClass: CardAdapterService},
  {provide: 'IDisplayTiam', useClass: TiamDisplayer},
  {provide: 'IManageTiam', useClass: TiamAdapterService},
  {provide: 'IDisplayUsers', useClass: UsersDisplayer},
  {provide: 'IDisplayMessages', useClass: MessagesDisplayer},
  {provide: 'IManageItems', useClass: ItemAdapterService},
  {provide: 'IManageUsers', useClass: UserAdapterService},
  {provide: 'IManageMessages', useClass: MessageAdapterService}]);

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));
